import { Component } from '@angular/core';

@Component({
  selector: 'app-modal-mein-position',
  templateUrl: './modal-mein-position.component.html',
  styleUrls: ['./modal-mein-position.component.scss']
})
export class ModalMeinPositionComponent {
  public isModalMainPositionShow: boolean = false;
  public isDarkBackground: boolean = false;

  openModalMainPositionShow() {
    this.isModalMainPositionShow = true;
    this.isDarkBackground = true;
  }

  closeModal() {
    this.isModalMainPositionShow = false;
    this.isDarkBackground = false;
  }
}
